import * as React from 'react';

const getCsrfToken = () => {
  const meta = document.querySelector('[name="csrf-token"]');
  return meta ? meta.content : '';
};

const defaultHeaders = () => ({
  'Accept': 'application/json',
  'X-CSRF-Token': getCsrfToken(),
});

const useCsrfFetchJson = () => {
  return React.useCallback(async (url, options = {}) => {
    const response = await fetch(url, {
      method: 'GET',
      credentials: 'same-origin',
      ...options,
      headers: {
        ...defaultHeaders(),
        ...(options.headers || {}),
      },
    });

    if (!response.ok) {
      throw new Error(`Request failed (${response.status})`);
    }

    return response.json();
  }, []);
};

export default useCsrfFetchJson;
